import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
		// dark: true,
		themes: {
			light: {
				primary: '#607d8b',
				secondary: '#90A4AE',
				accent: '#FFAB40',
				anchor: '#1976D2',
				error: '#f44336',
				warning: '#ff5722',
				info: '#03a9f4',
				success: '#4caf50',
				background: '#f6f6f6',
			},
			dark: {
				primary: '#607d8b',
				secondary: '#455A64',
				accent: '#FFAB40',
				anchor: '#90CAF9',
				error: '#f44336',
				warning: '#ff5722',
				info: '#03a9f4',
				success: '#4caf50',
				background: '#2f2f2f',
			}
		}
	},
	icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
});
